import { render } from "./SuperExamView.vue?vue&type=template&id=07d0fc1a&scoped=true"
import script from "./SuperExamView.vue?vue&type=script&lang=js"
export * from "./SuperExamView.vue?vue&type=script&lang=js"

import "./SuperExamView.vue?vue&type=style&index=0&id=07d0fc1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d0fc1a"]])

export default __exports__